<h2 class="fw-bold text-gray-900 mb-5 d-flex gap-2 align-items-center">
  <ui-keenicon [name]="icon()" [class]="iconClass()"></ui-keenicon>{{ text() }}:
</h2>
@if (separator()) {
  <div class="separator separator-dashed mb-5 w-100"></div>
}
